import { Component } from '@angular/core';

@Component({
  selector: 'stat-summary-footer-item',
  template: `<ng-content />`,
  host: {
    class:
      'flex grow basis-0 items-center justify-center gap-xs border-0 border-l border-solid border-default py-sm font-semibold text-support first:border-l-0 max-sm:basis-1/2',
  },
})
export class StatSummaryFooterItemComponent {}
